/* eslint-disable no-undef */
export default {
	name: "shipping-address-for-order",
	emits: ["shippingAddressSelected"],
	data() {
		return {
			shippingAddresses: [],
			customerHeadings: [
				{
					text: "Customer #",
					field: "companyId"
				},
				{
					text: "Customer Code",
					field: "customerCode"
				},
				{
					text: "Name",
					field: "registeredCompanyName"
				},
				{
					text: "ERP Customer Code",
					field: "erpCompanyCode"
				},
				{
					text: "VAT Number",
					field: "taxVatNumber"
				}
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			filter:{
				searchQuery: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			orderTotal: 0,
			newAssignedCustomers: [],
			newUnassignedCustomers: [],
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			loading: false
		};
	},
	methods: {
		getShippingAddresses(){
			let request = {
				companyId: this.companyId
			};
			customerService.getCompanyShippingAddresses(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.shippingAddresses = successResponse.data.result;
						for(let i = 0; i < this.shippingAddresses.length; i++){
							this.shippingAddresses[i].selected = false;
						}
						this.shippingAddresses = dataTableHelper.castFieldValues(this.shippingAddresses);
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
			this.shippingAddresses = dataTableHelper.castFieldValues(this.shippingAddresses);
		},
		onFilterSearchClicked(){
			//TODO: pass filter values to api
			this.getShippingAddresses()
		},
		onShippingAddressSelect(shippingAddressId){
			//let selectedShippingAddressId = shippingAddressId;
			// for(let i = 0; i < this.shippingAddresses.length; i++) {
			// 	this.shippingAddresses[i].selected = this.shippingAddresses[i].companyAddressId === shippingAddressId;
			// }
			this.$emit("shippingAddressSelected", shippingAddressId);
		}
	},
	mounted: function () {
        
	},
	watch:{
		companyId:{
			handler: function () {
				console.log("companyId", this.companyId);
				if(this.companyId !== null){
					this.getShippingAddresses();
				}
			},
			immediate: true,
			deep: true
		},
	}
};
